/**
 * Analytics event names for Admin app – roles & permissions (RBAC).
 */
export const ADMIN_ROLES_PAGE_VIEW = 'ADMIN_ROLES_PAGE_VIEW';
export const ADMIN_ROLE_ADD_VIEW = 'ADMIN_ROLE_ADD_VIEW';
export const ADMIN_ROLE_ADD_SUBMIT = 'ADMIN_ROLE_ADD_SUBMIT';
export const ADMIN_ROLE_EDIT_VIEW = 'ADMIN_ROLE_EDIT_VIEW';
export const ADMIN_ROLE_EDIT_SUBMIT = 'ADMIN_ROLE_EDIT_SUBMIT';
export const ADMIN_ROLE_VIEW = 'ADMIN_ROLE_VIEW';
export const ADMIN_ROLE_DELETE_SUBMIT = 'ADMIN_ROLE_DELETE_SUBMIT';
export const ADMIN_PERMISSIONS_VIEW = 'ADMIN_PERMISSIONS_VIEW';
export const ADMIN_ROLE_ASSIGNED_TO_USER = 'ADMIN_ROLE_ASSIGNED_TO_USER';
export const ADMIN_ROLE_REMOVED_FROM_USER = 'ADMIN_ROLE_REMOVED_FROM_USER';
